import { render, staticRenderFns } from "./jobNotice.vue?vue&type=template&id=34619f22&scoped=true&"
import script from "./jobNotice.vue?vue&type=script&lang=js&"
export * from "./jobNotice.vue?vue&type=script&lang=js&"
import style0 from "./jobNotice.vue?vue&type=style&index=0&id=34619f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34619f22",
  null
  
)

component.options.__file = "jobNotice.vue"
export default component.exports